import { useContext } from "react";

import styles from "./booking.module.scss";
import { bookingNavBarLogo } from "../../../constant";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { isPartnerBranding } from "../../../utils/partnerBranding";

function BookingNavBar({ onLogoClick }: { onLogoClick: () => void }): JSX.Element {
  const { branding }: iGlobalContext = useContext(StateContext);

  const partnerBranding = isPartnerBranding(branding);
  const logoSrc = (partnerBranding && (branding?.logoDarkUrl || branding?.logoUrl)) || bookingNavBarLogo;

  return (
    <div className={styles.header}>
      <img
        src={logoSrc}
        alt={partnerBranding && branding?.name ? `${branding.name} logo` : "logo"}
        className={styles.logo}
        onClick={onLogoClick}
      />
    </div>
  );
}

export default BookingNavBar;
